import { t } from '@lingui/core/macro';
import { useState } from 'react';

import LetteredAvatar from '@/components/LetteredAvatar';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  name?: string;
  domain?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
};

const CompanyLogo = ({ className, name, domain, size = 'small' }: Props) => {
  const displayName = name ?? domain;
  const [failed, setFailed] = useState(false);

  if (domain == null || failed) {
    return <LetteredAvatar name={displayName} shape="square" size={size} />;
  }

  const src = `https://logo.clearbit.com/${domain}`;

  return (
    <img
      className={cn(
        'my-auto',
        size === 'small' && 'max-h-5 max-w-5 rounded-sm',
        size === 'medium' && 'max-h-6 max-w-6 rounded-sm',
        size === 'large' && 'max-h-8 max-w-8 rounded-md',
        size === 'xlarge' && 'max-h-10 max-w-25 rounded-md',
        className,
      )}
      src={src}
      alt={displayName ? t`${displayName} logo` : t`Company logo`}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
};

export default CompanyLogo;
